import { render, staticRenderFns } from "./createChain.vue?vue&type=template&id=34ec098d&scoped=true&"
import script from "./createChain.vue?vue&type=script&lang=js&"
export * from "./createChain.vue?vue&type=script&lang=js&"
import style0 from "./createChain.vue?vue&type=style&index=0&id=34ec098d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ec098d",
  null
  
)

export default component.exports